import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isEqualWith from 'lodash/isEqualWith';
import ChevronDown from '../../../images/chevron-down.svg';

export default class Select extends React.Component {
	state = {
		showItems: false,
		selectedItem: {},
	};

	static propTypes = {
		items: PropTypes.arrayOf(
			PropTypes.shape({
				title: PropTypes.string.isRequired,
				id: PropTypes.string,
				selected: PropTypes.bool,
				disabled: PropTypes.bool,
			})
		).isRequired,
		onSelect: PropTypes.func.isRequired,
		disabled: PropTypes.bool,
		id: PropTypes.string,
	};

	componentDidMount() {
		this.setStateFromProps();
	}

	componentDidUpdate() {
		this.setStateFromProps();
	}

	setDefaultItem = newSelectedItem => {
		this.setState(
			({ selectedItem }) => {
				if (isEqual(selectedItem, newSelectedItem)) return null;
				return { selectedItem: newSelectedItem };
			},
			() => this.props.onSelect(this.state.selectedItem)
		);
	};

	setStateFromProps = () => {
		const { items, defaultItem } = this.props;
		const { selectedItem } = this.state;

		if (isEmpty(items) && isEmpty(selectedItem)) return;

		if (!isEmpty(selectedItem)) {
			const item = items.find(i => i.id === selectedItem.id);
			if (item && !isEqualWith(selectedItem, item)) {
				this.setDefaultItem(item);
				return;
			}
		}

		if (
			!isEmpty(selectedItem) &&
			items.find(i => i.id === selectedItem.id)
		) {
			return;
		}

		const firstItem = items[0];
		this.setDefaultItem(defaultItem || firstItem);
	};

	onChange = e => {
		const { items, onSelect } = this.props;

		const item = items.find(i => i.id === e.target.value);
		onSelect(item || {});

		this.setState({
			selectedItem: item
		});
	}

	render() {
		const { items, id, disabled, className } = this.props;

		return (
			<Dropdown
				id={id}
				onChange={this.onChange}
				disabled={disabled}
				className={className}
			>
				{(items || []).map(c => (
					<option disabled={c.disabled === true} key={c.id} value={c.id}>{c.title}</option>
				))}
			</Dropdown>
		);
	}
}

const Dropdown = styled.select`
	border: solid 1px #000;
	position: relative;
	background: no-repeat center right 0.5em url(${ChevronDown});
	border-radius: 5px;
	appearance: none;
	width: 100%;
	padding: 0.5em 2em 0.5em 0.5em;
	font-size: 1.2em;
	cursor: pointer;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	-ms-text-overflow: ellipsis;

	&.disabled,
	&.disabled:hover,
	&:disabled {
		cursor: default;
		font-style: italic;
		background: none;
	}

	&.disabled,
	&.disabled:hover {
		background-color: #d9d9d9;
		cursor: default;
	}
`;
